import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-copy",
  "use": "icon-copy-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"icon-copy\"><g stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 2.5v6.926c0 .593-.453 1.074-.997 1.074H1.497C.947 10.5.5 10.018.5 9.43V1.57C.5.98.951.5 1.505.5h4.997l1.998 2zM2.5 3.5h2M2.5 5.5h4M2.5 7.5h4\" /><path d=\"M8.5 4.5h4.002l1.998 2v6.926c0 .593-.453 1.074-.997 1.074H7.497c-.55 0-.997-.482-.997-1.07V10.5\" /><path fill=\"currentColor\" d=\"M6.5.5v2h2zM12.5 4.5v2h2z\" /><path d=\"M8.5 7.5h2M8.5 9.5h4M8.5 11.5h4\" /><path d=\"M9.5 4.5v5c0 .997-1.039 2-2.037 2H6.5\" opacity=\".4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-copy.svg
// module id = 871
// module chunks = 74